export const startRingTone = () => {
  try {
    const ringtone = document.getElementById("ringtone");
    ringtone.play();
  } catch (e) {}
};

export const stopRingTone = () => {
  const ringtone = document.getElementById("ringtone");
  try {
    ringtone.pause();
  } catch (e) {}
};

export const startRingbackTone = () => {
  const ringbacktone = document.getElementById("ringbacktone");
  try {
    ringbacktone.play();
  } catch (e) {}
};

export const stopRingbackTone = () => {
  const ringbacktone = document.getElementById("ringbacktone");
  try {
    ringbacktone.pause();
  } catch (e) {}
};

export const checkNotificationPermission = async () => {
  if (Notification.permission === "default") await Notification.requestPermission();
  return Notification.permission === "granted" ? true : false;
};
